module.exports = __webpack_public_path__ + "e4c5fec0348d60d4832e182608b4a92a.svg";